import * as types from '@/store/types/ui'
import { toggleToaster } from '@/store/actions'

const uiMiddleWare = store => dispatch => action => {
  if (action.type === types.SHOW_TOASTER) {
    setTimeout(() => {
      dispatch(
        toggleToaster({
          isVisible: false,
          message: '',
          position: 'top-right',
          type: 'info'
        })
      )
    }, 1000)
  }
  return dispatch(action)
}

export default [uiMiddleWare]



// WEBPACK FOOTER //
// ./src/store/mniddlewares/ui.middleware.js